// extracted by mini-css-extract-plugin
export default {"section":"Section_section__6Xcf8","childWrapper":"Section_childWrapper__5p-+s"};